<template>
    <div>
        <div class="card-header">
            <h3>{{ $t("lang.label_mn_spcl_wget") }}</h3>
        </div>
        <div class="card-body" style="min-height: 200px">
            <div class="bgloading" v-show="isLoading"><Loader></Loader></div>
            <div class="row" v-if="isCode">
                <div class="col-sm-12">
                    <!-- <textarea id="codeHtml"  style="height: 200px;width:100%;display:block;" readonly onClick="this.select()">&#60;div id="appMenuSpc"&#62;&#60;/div&#62;&#60;script id="appScriptMenuSpc"&#62;var d=document,appMenuSpc={{ org_id }},IdDivSpc="appMenuSpc",IdMenuSpc="widgetSpc",f=new Date,urlSpc="{{url}}api/widget/appw2/",t=d.querySelector("#appScriptMenuSpc"),s=d.createElement("script");s.type="text/javascript",s.id="widgetMenuSpcScript",s.defer=!0,s.src=urlSpc+appMenuSpc+"/"+f.getTime(),t.parentNode.insertBefore(s,t);&#60;/script&#62;</textarea> -->
                    <textarea
                        id="codeHtml"
                        style="height: 200px; width: 100%; display: block"
                        readonly
                        onClick="this.select()"
                        v-model="uriOrigin"
                    ></textarea>
                </div>
                <div class="col-12">
                    <button class="btn btn-primary" @click="copyhtml">
                        {{ $t("lang.label_cc") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Loader from "@/components/shared/Loader.vue";
export default {
    name: "widgetCodeSpc",
    components: {
        Loader,
    },
    data () {
        return {
            url: window.urlmaster,
            org_id: window.localuserdata,
            isLoading: false,
            isCode: true,
            uriOrigin:
                '<div id="appMenuSpc"></div><script id="appScriptMenuSpc">var d=document,appMenuSpc=' +
                window.localuserdata +
                ',IdDivSpc="appMenuSpc",IdMenuSpc="widgetSpc",f=new Date,urlSpc="' +
                window.urlmaster +
				// eslint-disable-next-line no-useless-escape
                'api/widget/appw2/",t=d.querySelector("#appScriptMenuSpc"),s=d.createElement("script");s.type="text/javascript",s.id="widgetMenuSpcScript",s.defer=!0,s.src=urlSpc+appMenuSpc+"/"+f.getTime(),t.parentNode.insertBefore(s,t);<\/script>',
        }
    },
    methods: {
        copyhtml() {
            var element = document.querySelector("#codeHtml").select();
            try {
                document.execCommand("copy");
                this.$swal({
                    type: "success",
                    title: window.lang2.msj_ccd,
                    timer: 1000,
                });
            } catch (err) {
                console.log("unable to copy code");
            }
        },
    },
};
</script>
<style lang="scss" scoped></style>
